import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-analytics-team-overview',
    templateUrl: './analytics-team-overview.component.html',
    styleUrls: ['./analytics-team-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnalyticsTeamOverviewComponent {
  @Input() analytics: any;
}
